<ng-template [ngIf]="!loading">      
    <div class="content-inner">
        <form [formGroup]="enterUOSActualForm" *ngIf="!loadingRecords">
            <div *ngFor="let block of shiftBlocks" class="shift-block workflow-input">
                <label for="{{ getShiftBlockControlName(block.id) }}">{{ getShiftBlockLabel(block) }}</label>
                <smt-enter-actual-uos-block #EnterActualUosEditForm 
                    [shiftRecord]="getShiftRecordByShiftBlockId(block.id)"
                    [enterActualForm]="enterUOSActualForm"
                    [enterByBlock]="ancillaryConfiguration.enterUOSByBlock">
                </smt-enter-actual-uos-block>
            </div>
        </form>       
        <div *ngIf="!loadingRecords && !hasShiftBlocks() && ancillaryConfiguration.enterUOSByBlock" class="no-previous-block">This cost center has no previous shift block.  Please proceed to the next page.</div>
        <div *ngIf="!loadingRecords && !hasShiftBlocks() && !ancillaryConfiguration.enterUOSByBlock" class="no-previous-block">This cost center has no previous working day.  Please proceed to the next page.</div>
        <div class="loading" *ngIf="loadingRecords"></div>
    </div>
</ng-template>